import { formatPhone } from "../../layouts/helpdeskLayout/HelpdeskRail";

// Estados de la integración en los que el backend YA NO envía por ese número:
// la respuesta cae al primer número de mesa de ayuda del operador
// (outbound-dispatcher de microservice-conversations).
const NOT_SENDABLE_STATUSES = new Set(["inactive", "error"]);

/**
 * Aviso del editor sobre por qué número saldrá la respuesta, o null si sale por
 * el número de la conversación sin problemas. Solo WhatsApp no oficial: es el
 * único canal donde la respuesta puede salir por otro número.
 *
 * @param {object|null|undefined} account channel_account de la conversación
 *   ({ phone, label, retired, status, wa_connection_status }).
 * @param {string|undefined} channel canal de la conversación.
 * @param {(key: string) => string} t traductor.
 * @returns {{tone: "warning", text: string}|null}
 */
export function replyRouteNotice(account, channel, t) {
  if (channel !== "whatsapp_unofficial" || !account) return null;
  const name = formatPhone(account.phone) || account.label || "";

  if (account.retired) {
    return {
      tone: "warning",
      text: t(
        "El número {{numero}} está retirado. Tu respuesta saldrá por otro número de la mesa de ayuda y la conversación pasará a ese número."
      ).replace("{{numero}}", name),
    };
  }
  if (NOT_SENDABLE_STATUSES.has(account.status)) {
    return {
      tone: "warning",
      text: t(
        "El número {{numero}} está desvinculado. Tu respuesta saldrá por otro número de la mesa de ayuda y la conversación pasará a ese número."
      ).replace("{{numero}}", name),
    };
  }
  if (account.wa_connection_status && account.wa_connection_status !== "open") {
    return {
      tone: "warning",
      text: t(
        "El número {{numero}} está sin conexión: el envío puede fallar hasta que se reconecte."
      ).replace("{{numero}}", name),
    };
  }
  return null;
}
